import { Instance, SnapshotIn, SnapshotOut, types } from 'mobx-state-tree';
import { IUserImageAreaModel } from './userImageArea';
import { PreviewModel, ViewBoxModel } from './preview';
import { ProductCategoryCode } from '@photosi/expo-photosi-sdk/build/Product';
import { IUserTextAreaModel } from './userTextArea';

export type TPreviewVintageModel = typeof PreviewVintageModel;
export type PreviewVintageModelInstance = Instance<TPreviewVintageModel>;
export interface IPreviewVintageModelIn extends SnapshotIn<TPreviewVintageModel> {}
export interface IPreviewVintageModelOut extends SnapshotOut<TPreviewVintageModel> {}
export interface IPreviewVintageModel extends PreviewVintageModelInstance {}

export const PreviewVintageModel = PreviewModel.named('PreviewVintageModel')
  .props({
    type: types.union(
      types.literal(ProductCategoryCode.VINTAGE)
    ),
    viewBox: ViewBoxModel,
    backgroundViewBox: ViewBoxModel,
  })
  .views(self => ({
    get useImageArea(): IUserImageAreaModel {
      return <IUserImageAreaModel>self.userImageAreas[0];
    },
    get useTextArea(): IUserTextAreaModel {
      return <IUserTextAreaModel>self.userTextAreas[0];
    },
  }))
  .views(self => ({
    get currentUserImage() {
      return self.useImageArea.userImage;
    },
  }))
  .views(self => ({
    get backgroundColor(): string | undefined {
      return self.currentUserImage?.backgroundColor;
    },
  }))
  .views(self => ({
    get hasBorder(): boolean {
      return !(
        self.userImageArea.x === self.backgroundViewBox.x &&
        self.userImageArea.y === self.backgroundViewBox.y &&
        self.userImageArea.width === self.backgroundViewBox.width &&
        self.userImageArea.height === self.backgroundViewBox.height
      );
    },
  }));
